import React, {Component} from 'react';
import {connect, Provider} from 'react-redux';
import Localized from 'toluna-frontend-components/IntlProvider/Localized';
import configureStore from '@/store/configureStore';

const store = configureStore();

const pureApp = (props) => {
  return (
	  <Provider store={store}>
		<div id="ta-react-app" style={{'overflowY': 'hidden'}}>

		</div>
	  </Provider>
  );
};

const mapStateToProps = (state) => {
  return {
	report: state.report
  }
};

export const connectedApp = connect(mapStateToProps, null)((props) => {
  //console.log('App: ', props);
  return (

	  <div id="ta-react-app">
		<props.intl.Message id="translation"/>
		<props.intl.Message id="translationWithParams" args={['LOL', 'LOL 2']}/>
	  </div>
  );
});


export const LocalizedApp = Localized(pureApp);

export default LocalizedApp;



// WEBPACK FOOTER //
// ./App.js